/**
 * Returns the path for MoloLink pages.
 * MoloLink only runs on mololink.molochain.com subdomain.
 * Always returns direct path like "/marketplace", "/home", etc.
 */
export function mololinkPath(path: string): string {
  return path.startsWith('/') ? path : '/' + path;
}

/**
 * Checks if the current location matches a mololink path.
 */
export function isActiveMololink(path: string, location: string): boolean {
  const clean = path.startsWith('/') ? path : '/' + path;
  return location === clean || location.startsWith(clean + '/');
}
